import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HomePage } from './home.page';
import { SharedModuleModule } from '../../shared-module/shared-module.module';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		NgcCookieConsentModule,
		RouterModule.forChild([
			{
				path: '',
				component: HomePage,
			},
		]),
		SharedModuleModule,
	],
	declarations: [HomePage],
})
export class HomePageModule {}
